export enum ActivityMethods {
    Phone = 'phone',
    Email = 'email',
    Text = "text",
    InPerson = "in person",
    VideoChat = "video chat",
    Other = "other"
}
    
export enum ActivityResults {
    Conversation = "conversation",
    LeftMessage = "left message",
    Other = "other"
}